import { createSelector } from '@reduxjs/toolkit';

import type { ReduxApplicationState } from 'src/redux/combinedReducer';

export interface HeaderCopyBlockContent {
  description?: string;
  heading?: string;
  subheading?: string;
}

const selectContent = (state: ReduxApplicationState) => state.content;
const selectCurrentPage = (state: ReduxApplicationState) => state.productsQuery?.page;

/**
 * Content for the category route's header copy block, sourced from the category
 * content entry. Intro copy is shown only on the first PLP page, keyed off the
 * logical page number (`productsQuery.page`) rather than `products.pages`
 * membership: the latter is emptied during the products refetch on a
 * filter/sort change, which made the intro copy flicker. This mirrors the shop
 * route's `selectTaxonomyHeaderContent`. This is category-only.
 */
export const selectHeaderCopyBlockContent = createSelector(
  [selectContent, selectCurrentPage],
  (content, page): HeaderCopyBlockContent => {
    const category = content.category;

    if (!category?.heading) {
      return {};
    }

    return {
      heading: category.heading,
      subheading: category.subheading,
      description: page === 1 ? category.description : undefined,
    };
  },
);
